<template>
  <div class="card" v-if="itemisedBillGroup.length > 0">
    <div class="card-header" :id="'heading' + _uid">
      <component :is="tag" data-toggle="collapse" :data-target="'#card' + _uid" aria-expanded="true"
                 :aria-controls="'card' + _uid" class="collapsed">
        <dyn-slot tag="div" :hideParentEnvironment="false" class="row"><slot name="headline">click me</slot></dyn-slot>
      </component>
    </div>
    <div :id="'card' + _uid" :class="{collapse: true, show: show}" :aria-labelledby="'heading' + _uid">
      <div class="card-body row" v-if="itemisedBillGroup.length > 0">
        <div class="itemised-bill-table">
          <div class="row header">
            <div class="col bill_col1"><slot name="col1Header">Datum</slot></div>
            <div class="col bill_col2"><slot name="col2Header">Uhrzeit</slot></div>
            <div class="col bill_col3"><slot name="col3Header">Rufnummer</slot></div>
            <div class="col bill_col4"><slot name="col4Header">Dauer</slot></div>
            <div class="col bill_col5"><slot name="col5Header">Kosten</slot></div>
          </div>
          <div class="row body" v-for="bill in getItemisedBills" :key="bill.id">
            <div class="col bill_col1">
              <div class="responsive-label"><slot name="col1Header">Datum</slot></div>
              <dyn-slot :slot-data="bill" :hideParentEnvironment="false">
                <slot name="col1Content">{{ dateFormatter(bill.actionDate) }}</slot>
              </dyn-slot>
            </div>
            <div class="col bill_col2">
              <div class="responsive-label"><slot name="col2Header">Uhrzeit</slot></div>
              <dyn-slot :slot-data="bill" :hideParentEnvironment="false">
                <slot name="col2Content">{{ timeFormatter(bill.actionDate) }}</slot>
              </dyn-slot>
            </div>
            <div class="col bill_col3">
              <div class="responsive-label"><slot name="col3Header">Rufnummer</slot></div>
              <dyn-slot :slot-data="bill" :hideParentEnvironment="false">
                <slot name="col3Content">{{ bill.destination }}</slot>
              </dyn-slot>
            </div>
            <div class="col bill_col4">
              <div class="responsive-label"><slot name="col4Header">Dauer</slot></div>
              <dyn-slot :slot-data="bill" :hideParentEnvironment="false">
                <slot name="col4Content">{{ durationFormatter(bill.duration) }}</slot>
              </dyn-slot>
            </div>
            <div class="col bill_col5">
              <div class="responsive-label"><slot name="col5Header">Kosten</slot></div>
              <dyn-slot :slot-data="bill" :hideParentEnvironment="false">
                <slot name="col5Content">{{ currencyFormatter(bill.value / 10000) }}</slot>
              </dyn-slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ItemisedBillingList',
  computed: {
    getItemisedBills () {
      return this?.itemisedBillGroup
    },
    sum () {
      const summe = this.itemisedBillGroup.reduce(function (pv, cv) { return pv + parseInt(cv.value) }, 0)
      return summe
    },
    headerSlotData () {
      return {
        sum: this.sum || 0,
        count: this.itemisedBillGroup.length || 0,
        currencyFormatter: this.$config.calendar.formatter.currencyFormatter
      }
    }
  },
  props: {
    itemisedBillGroup: {
      type: Array,
      default: () => []
    },
    tag: {
      type: String,
      default: 'h5'
    },
    show: {
      type: Boolean,
      default: false
    },
    mapping: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    dateFormatter (date) {
      const d = new Date(date)
      const year = d.getFullYear()
      const century = Math.floor(year / 100)
      const rest = year % 100

      return this.$_makeTwoDigist(d.getDate()) + '.' +
        this.$_makeTwoDigist(d.getMonth() + 1) + '.<span class="century">' +
        this.$_makeTwoDigist(century) + '</span>' + this.$_makeTwoDigist(rest)
    },
    timeFormatter (date) {
      const d = new Date(date)
      const h = d.getHours()
      const m = d.getMinutes()
      const s = d.getSeconds()

      return this.$_makeTwoDigist(h) + ':' +
        this.$_makeTwoDigist(m) + '<span class="seconds">:' +
        this.$_makeTwoDigist(s) + '</span>'
    },
    dateTimeFormatter (date) {
      return this.$config.calendar.formatter.dateTimeFormatter.format(new Date(date))
    },
    currencyFormatter (value) {
      return this.$config.calendar.formatter.currencyFormatter.format(value)
    },
    durationFormatter (value) {
      if (!value) return ''

      const date = new Date(1900, 1, 1, Math.floor(value / 3600), Math.floor(value / 60) % 60, Math.floor(value % 60))
      return this.$config.calendar.formatter.timeFormatter.format(date)
    },
    $_makeTwoDigist (n) {
      return n > 9 ? '' + n : n < 100 ? '0' + n : '' + n
    }
  }
}
</script>
